import { Button, Toolbar } from "@fluentui/react-components";
import React, { ReactNode } from "react";

import styles from "./selectionBar.module.css";

// 行を選んだときにヘッダー行に重ねて出す一括操作のバー。出す条件と文言は画面ごとに違うため呼び出し側で決める
export const GridTableSelectionBar: React.FC<{
  clearLabel: string;
  onClear: () => void;
  ariaLabel: string;
  children?: ReactNode;
}> = ({ clearLabel, onClear, ariaLabel, children }) => {
  return (
    <div className={styles.selectionBar}>
      <Toolbar size="small" aria-label={ariaLabel}>
        <Button appearance="subtle" size="small" onClick={onClear}>
          {clearLabel}
        </Button>
        {children}
      </Toolbar>
    </div>
  );
};
